<div class="form-subtitle flex-basis-100 mb-16 text-16" i18n>
  Assurances à centraliser
</div>
<div class="insurances-list">
  <div class="form-check" *ngFor="let insurance of InsuranceTypes">
    <input
      class="form-check-input"
      [id]="insurance"
      type="checkbox"
      [checked]="selectedInsurances.includes(insurance)"
      (change)="handleChange(insurance, $event)"
    />
    <label class="form-check-label" [for]="insurance">{{
      getInsuranceTypeLabel(insurance)
    }}</label>
  </div>
</div>
<div class="insurers-list" *ngIf="selectedInsurances?.length">
  <div class="form-subtitle flex-basis-100 mb-16 text-16" i18n>Assureurs</div>
  <div *ngFor="let insurance of selectedInsurances">
    <h6 class="mb-3">{{ getInsuranceTypeLabel(insurance) }}</h6>
    <mat-form-field class="lty-input">
      <mat-select [formControl]="getControl(insurance)" multiple>
        <mat-option
          *ngFor="
            let company of getCompanyOptions(insurance);
            trackBy: trackByOptionValue
          "
          [value]="company.value"
          >{{ company.label }}</mat-option
        >
      </mat-select>
    </mat-form-field>
  </div>
</div>
